/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import config from "../config/config";
import Fotter from "./fotter";
import Header from "./header";
import UpcomingNav from "./upcomingNav";

function Events() {
  const [eventsData, setEventsData] = useState([]);
  const [newsData, setNewsData] = useState([]);
  const [eventBtns, setEventBtns] = useState([]);
  const [newsBtns, setNewsBtns] = useState([]);
  const moment = require("moment");

  async function getNewsData() {
    var myNews = new Headers();
    var requestOptions = {
      method: "GET",
      headers: myNews,
      redirect: "follow",
    };
    let newsData = [];
    await fetch(config.base_url + "api/recent_news", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        newsData = JSON.parse(result);
        setNewsData(newsData.data);
        setNewsBtns(JSON.parse(newsData.data[0].actions));
      })
      .catch((error) => console.log("error", error));

    return newsData;
  }

  async function getEventsData() {
    var myEvent = new Headers();
    var requestOptions = {
      method: "GET",
      headers: myEvent,
      redirect: "follow",
    };
    let eventsData = [];
    await fetch(config.base_url + "api/upcoming", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        eventsData = JSON.parse(result);
        setEventsData(eventsData.data);
        setEventBtns(JSON.parse(eventsData.data[0].actions));
      })
      .catch((error) => console.log("error", error));

    return eventsData;
  }

  useEffect(() => {
    getEventsData();
    getNewsData();
  }, []);

  return (
    <>
      <Header />
      <UpcomingNav />
      <div id="eventsArea" className="eventsArea">
        <div className="container">
          <div className="row">
            {eventsData.map((event, index) => (
              <div className="col-12" key={index}>
                <div className="singleEvent">
                  <div className="row align-items-center">
                    <div className="col-md-9">
                      <span className="eventDate">
                        {moment(event.date).format("MMMM Do YYYY")}
                      </span>
                      <div
                        className="eventDetailes"
                        dangerouslySetInnerHTML={{
                          __html: event.title,
                        }}
                      ></div>
                    </div>
                    <div className="col-md-3 justify-content-end d-flex">
                      {eventBtns.map((eventBtn, childIndex) => (
                        <Link
                          to={eventBtn.url}
                          className="eventBtn"
                          key={childIndex}
                        >
                          {eventBtn.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Fotter />
    </>
  );
}

export default Events;
